import React, { Component, PropTypes } from 'react';
import ModalDialog from 'common/components/modal/modal_dialog';
import PDF from 'common/components/pdf';
import { TextInputField, SelectField } from 'common/components/form_fields';
import AnimatedButton from 'common/components/animated_button';

/**
 * Modal used to sign contracts.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class SignContract extends Component {
  constructor(props) {
    super(props)
    this.state = { font: 'give-you-glory', content: '', collapsed: true }
    this.sign = this.sign.bind(this)
    this.onDone = this.onDone.bind(this)
    this.uncollapse = this.uncollapse.bind(this);
  }

  componentDidMount() {
    this.props.fetchFontsIfNeeded()
  }

  getStyleFont(fonts, font) {
    const choice = fonts.find((f) => f.field == font)
    return choice? choice.label:''
  }

  onDone() {
    const {onDone, onClose} = this.props
    if (onDone) {
      onDone()
    }
    onClose()
  }

  uncollapse() {
    this.setState({ collapsed: false });

    if (this.props.onUncollapse) {
      this.props.onUncollapse();
    }
  }

  sign() {
    const {signingAs, contract, sign, customSignRequest} = this.props
    const {content, font} = this.state
    sign(contract.id, {content, font, signing_as: signingAs}, this.onDone, customSignRequest)
  }

  render() {
    const {
      showing, fonts, onClose, isSigning, error, contract, header, children, collapsable,
      uncollapseLabel, title, uncollapsedTitle, uncollapsedHeader, uncollapseDisabled,
      signingAs
    } = this.props;
    const { font, content, collapsed } = this.state;
    const shouldCollapse = collapsable && collapsed;
    const primaryComponent = (
      <AnimatedButton processing={isSigning} label="Sign contract" processingLabel="Signing..."
        onClick={this.sign} errorMsg={error} successMsg="Done!" disabled={!content.trim()}
        baseBtnClass={signingAs === "creative"? "btn btn-tertiary btn-block" : undefined} />
    );
    const topTitle = collapsable && !collapsed? uncollapsedTitle || title : title;
    const modalHeader = collapsable && !collapsed? uncollapsedHeader : header;

    return (
      <ModalDialog
        modalOpen={showing}
        closeAction={onClose}
        dialogClasses="sign-contract"
        primaryComponent={shouldCollapse? undefined: primaryComponent}
        primaryLabel={shouldCollapse? uncollapseLabel : undefined}
        onPrimary={shouldCollapse? this.uncollapse : undefined}
        primaryDisabled={shouldCollapse? uncollapseDisabled : false}
        onSecondary={onClose}
        secondaryLabel="Cancel"
        modalHeader={modalHeader || "Sign Contract"}
      >

        { topTitle && <h2>{ topTitle }</h2> }

        { shouldCollapse?
        children :
        <div>
          <div className="hide-for-small-only">
            <PDF key={contract.pdf} url={contract.pdf}/>
          </div>

          <a href={contract.pdf} target="_blank" className="btn btn-secondary show-for-small-only">
            <i className="fa fa-file-text"></i> Open Contract
          </a>

          <fieldset>
            <h4 className="text-success">Add your name below:</h4>

            <div className="row">
              <div className='columns small-16 medium-8'>
                <TextInputField meta={{}} label="Full Name"
                   input={{
                     value: content,
                     name: "content",
                     onChange: (e) => this.setState({content: e.target.value})
                   }}/>
              </div>
              <div className='columns small-16 medium-8'>
                <SelectField meta={{}} label="Font" options={fonts}
                   input={{
                     value: font,
                     name: "font",
                     onChange: (e) => this.setState({font: e.target.value})
                   }}/>
              </div>
            </div>
            <div className="row columns small-16">
              <h1 style={{fontFamily: this.getStyleFont(fonts, font)}}>
                {content || "Your Name"}
              </h1>
            </div>
          </fieldset>
        </div> }
      </ModalDialog>
    )
  }
}

SignContract.propTypes = {
  contract: PropTypes.object,
  showing: PropTypes.bool,
  signingAs: PropTypes.string,
  fonts: PropTypes.array,
  isSigning: PropTypes.bool,
  error: PropTypes.string,
  fetchFontsIfNeeded: PropTypes.func,
  onDone: PropTypes.func,
  onClose: PropTypes.func,
  sign: PropTypes.func,
  customSignRequest: PropTypes.func,
  header: PropTypes.string,
  collapsable: PropTypes.bool,
  uncollapseLabel: PropTypes.string,
  title: PropTypes.string,
  uncollapsedTitle: PropTypes.string,
  uncollapsedHeader: PropTypes.string,
  onUncollapse: PropTypes.func,
  uncollapseDisabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./common/components/modal/sign_contract.jsx